module.exports = "/images/london-5.jpg";